<div class="conteudo-equipamentos">
  <div class="opcoes">
    <div class="p-3">
      <div class="titulo">
        <span>Equipamentos</span>
      </div>

      <div class="sub-titulo my-2">
        Patrimonio: {{detalheEquipamento.numPat ?? 'Sem dados'}} | N de Série: {{detalheEquipamento.numSerie}}
      </div>
      <app-botao-voltar></app-botao-voltar>
      <hr>

      <div class="detalhes-equipamentos">

        <mat-card>
          <mat-card-content class="header-card">
            <b>Informações do equipamento</b>
          </mat-card-content>
          <mat-card-content class="content-card">
            <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
            <ng-template #apnetworksCliente>
              <b>Cliente:</b> {{(detalheEquipamento.nomeCliente || detalheEquipamento.nomeFantasiaCliente) ??
              'N/A'}}<br>
            </ng-template>
            <ng-template #kmDoBrasilCliente>
              <b>Cliente:</b> {{(detalheEquipamento.nomeFantasiaCliente || detalheEquipamento.nomeCliente) ??
              'N/A'}}<br>
            </ng-template>
            <b>N de Série:</b> {{detalheEquipamento.numSerie}}<br>
            <b>Marca:</b> {{detalheEquipamento.nomeMarcaProduto ?? 'N/A'}}<br>
            <b>Modelo:</b> {{detalheEquipamento.modelo ?? 'N/A'}}<br>
            <b>Localização:</b> {{detalheEquipamento.local ?? 'Sem dados'}} <span
              *ngIf="autorizacoes.editarEquipamento"> - <button class="btn-visualizar"
                (click)="editarLocalizacao(detalheEquipamento)" [title]="'Editar Localização'">Editar
                Localização</button></span>

            <app-modal-editar-equipamento-localizacao></app-modal-editar-equipamento-localizacao>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="this.chamados.length > 0">
          <mat-card-content class="header-card">
            <b>Sobre o chamado</b>
          </mat-card-content>
          <mat-card-content class="content-card">
            <div>
              <!-- style="color: #007AF2" -->
              <b>Último chamado: </b><button class="btn-visualizar"
                [routerLink]="['/historico-de-chamados', params.numSerie, params.codContrato]"
                [queryParams]="{codigoOs: chamados[0].codigoOS}">Visualizar</button><br>
            </div>
            <p>
              <b>Motivo real do chamado:</b> {{chamados[0].motivo || 'Motivo não declarado'}}
            </p>
          </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-content class="header-card chart-header">
            <h4>Produção mensal</h4>
            <p>Últimos 12 meses</p>
          </mat-card-content>
          <mat-card-content id="chart" class="content-card">

            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
              [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
              [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [fill]="chartOptions.fill"
              [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [xaxis]="chartOptions.xaxis"></apx-chart>

          </mat-card-content>
        </mat-card>

        <ng-container *ngIf="this.chamados.length > 0">
          <mat-card>
            <mat-card-content>
              <table class="table">
                <thead>
                  <tr class="tr__style">
                    <th scope="col">Chamado</th>
                    <th scope="col">Data</th>
                    <th scope="col">Aberto por</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- style="color: #007AF2" -->
                  <tr *ngFor="let chamado of chamados" [ngSwitch]="chamado.status">
                    <td><button class="btn-visualizar"
                        [routerLink]="['/historico-de-chamados', params.numSerie, params.codContrato]"
                        [queryParams]="{codigoOs: chamado.codigoOS}">{{ chamado.codigoOS
                        }}</button></td>
                    <td>{{ chamado.dataAbertura | date:'dd/MM/yyyy' }}</td>
                    <td>{{ chamado.solicitante }}</td>
                    <td>{{ chamado.status }}</td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
          </mat-card>
        </ng-container>


      </div>
    </div>
  </div>
</div>